<script setup lang="ts">
import type { DynamicAuctionItemDetails, SharedSeo } from '@autobid/strapi-integration/rest/components'
import type { Ref } from 'vue'
import { useDetailsCar } from '@autobid/ui/composables/car/data/useDetailsCar'
import { useCarSeoMeta } from '@autobid/ui/composables/car/useCarSeoMeta'
import { useAuction } from '@autobid/ui/composables/useAuction'
import { STRAPI_SEO_INJECTION_KEY } from '@autobid/ui/constants/STRAP_SEO_INJECTION_KEY'
import { computed, inject } from 'vue'

const props = defineProps<DynamicAuctionItemDetails>()
const isPdfPage = inject('isPdfPage', false)
const carId = useState('carId') as Ref<number>
const strapiSeo: SharedSeo | null = inject(
  STRAPI_SEO_INJECTION_KEY,
  null,
)
const { data: car } = useDetailsCar(carId, {
  keepPreviousData: true,
})
const { auction } = useAuction(car.value?.item.itemData.auctionId ?? 0, {
  enabled: !isPdfPage,
})

const carItemData = computed(() => car.value?.item.itemData)

if (!isPdfPage) {
  useCarSeoMeta(strapiSeo, carItemData, auction)
}
</script>

<template>
  <SectionsDetailsApp
    v-if="!isPdfPage && carItemData && car"
    v-bind="props"
    :car="carItemData"
    :details="car.item.itemDetails"
    :auction-car-pagination="car.metadata"
  />
  <SectionsDetailsPdf v-else-if="car" :car="car.item.itemData" :details="car.item.itemDetails" />
</template>
